import React from 'react';
import { BaseRatesGrid } from '../../grids';

const CptGroupersTab: React.FC = () => {
  return <BaseRatesGrid />;
};

export default CptGroupersTab;
